module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-sanction/payroll-sanction-grid/payroll-sanction-grid.component.css
// module id = ./src/app/hrms/payroll/payroll-sanction/payroll-sanction-grid/payroll-sanction-grid.component.css
// module chunks = main